//address type
export const pick_up = "1";
export const drop_off = "2";

//Customer Requests tab constants

export const active = "0";
export const completed = "1";
export const cancelled = "2";

export const get_request_status = (
  status,
  request_type = false,
  additional_status
) => {
  if (status === 0) {
    return "New Request";
  }
  if (status === 1) {
    return "Bid submitted";
  }
  if (status === 2) {
    return request_type ? "Waiting for company response" : "Bid accepted";
  }

  console.log(additional_status, "additional_status");
  if (status === 3) {
    return request_type
      ? additional_status === 0
        ? "Awaiting Customer Response"
        : "Direct Request Accepted"
      : "Paid and waiting for move";
  }
  if (status === 4) {
    return "Truck assigned and ready to move";
  }
  if (status === 5) {
    return "Move in progress";
  }
  if (status === 6) {
    return "Completed, waiting for confirmation";
  }
  if (status === 7) {
    return "Completed";
  }
  if (status === 8) {
    return "Feedback Given";
  }
  if (status === 11) {
    return "Bid Cancelled";
  }
};

export const SORT_BY_OPTIONS = [
  { label: "Request ID", value: "id" },
  { label: "Movers", value: "movers" },
  { label: "Schedule Time", value: "schedule_time" },
  { label: "Move Type", value: "move_type" },
  { label: "Net Distance", value: "net_distance" },
  { label: "Request Timeline Status", value: "request_timeline_status" },
];

export const TIMELINE_STATUS_OPTIONS = [
  { label: "All Requests", value: "" },
  { label: "New Request", value: "0" },
  // { label: "Bid submitted", value: "1" },
  // { label: "Bid accepted", value: "2" },
  { label: "Awaiting Customer Response", value: "3" },
  { label: "Direct Request Accepted", value: "3.1" },
  { label: "Truck assigned and ready to move", value: "4" },
  { label: "Move in progress", value: "5" },
  { label: "Completed, waiting for confirmation", value: "6" },
  { label: "Completed", value: "7" },
  { label: "Feedback Given", value: "8" },
];
